module.exports = __webpack_public_path__ + "img/4_123.8b171c0f.png";